<template>


  <el-backtop class="back-top"/>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";


export default {
  name: "Home",
  props: {
    partnerImage: {
      type: String
    }
  },
  setup() {
    const data = reactive({
    });


    onMounted(() => {
    });

    return {
      ...toRefs(data),
    };
  }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
</style>